import { runInAction, makeAutoObservable, toJS } from "mobx";
import { callRemoteMethod } from "../utils/WebserviceHandler";
import CONSTANTS from "../utils/constants";
import User from "./UserStore";
import { ErrorWrapper } from "../utils/ErrorWrapper";
import GeneralStore from "./GeneralStore";
import { NotifySuccess } from "../utils/ShowSuccess";
import { NotifyError } from "../utils/ShowError";
import { filsToAmountString, sumFils } from "../utils/money";
import { run } from "node:test";

interface Obj {
  [key: string]: any;
}

class RefundAndTransfer {
  negativeAccounts: Obj = {};
  destinationAccountsList: Obj[] = [];
  refundHistory: Obj[] = [];

  transferResponse: Obj = {};
  refundResponse: Obj = {};

  selectedAccounts: Obj[] = [];
  otp: string = "";
  cashPayoutResponse: Obj = [];

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true, deep: true });
  }

  getNegativeAccountDetails = ErrorWrapper(async (personId: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.NEGATIVE_ACCOUNT_BALANCES(personId),
    });

    runInAction(() => {
      this.negativeAccounts = res.result;
    });
  });

  getDestinationAccountsList = ErrorWrapper(async (personId: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.DESTINATION_ACCOUNTS_LIST(personId),
    });

    runInAction(() => {
      this.destinationAccountsList = res.result.output.accountList;
    });
  });

  makeTransfer = ErrorWrapper(async (destAccountId: string) => {
    const transferBalanceAccountList: Obj[] = this.selectedAccounts.map(
      (account) => {
        return {
          sourceAccountId: account.accountId,
          transferAmount: account.accountBalance,
          destAccountId,
        };
      }
    );

    const data = {
      transferBalanceAccountList,
    };

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.TRANSFER(User?.profile?.personId),
      type: "POST",
      data,
    });
    // if(res?.data?.result.status=="SUCCESS"){
    //     const message= GeneralStore?.codeLabels[res?.data?.result?.message]?.label;
    //     const [msg, ref] = message.split('|');
    //     const cleanedRef = ref.replace(/'/g, '');
    //     const updatedMessage = message.replace('(Reference # %1)', cleanedRef);
    //     NotifySuccess(updatedMessage)
    //   }

    runInAction(() => {
      this.transferResponse = res.result;
    });
  });

  makeRefund = ErrorWrapper(async (bankDetails: Obj) => {
    const accountList: Obj[] = this.selectedAccounts.map((account) => {
      return {
        accountId: account.accountId,
        amount: account.accountBalance,
      };
    });

    // Summed in fils: the previous reduce had no else branch, so the first
    // account with a zero or absent balance made it return undefined and
    // totalAmount.toFixed(2) threw. It also has to agree to the fil with the
    // accountList[].amount values sent in the same body.
    const totalAmount = filsToAmountString(
      sumFils(this.selectedAccounts.map((account) => account.accountBalance))
    );

    const data = {
      accountList,
      totalAmount,
      bankDetails: {
        ...bankDetails,
        action: null,
        refundType: "BANK",
      },
    };

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.REFUND(User?.profile?.personId),
      type: "POST",
      data,
    });
    if (res?.result.status == "FAIL") {
      const msgs = res?.result?.statusMessage;
      if (msgs.includes("MSG")) {
        var [msg, value1, value2, value3] = msgs.split("|");
        msg = ("cm_" + msg).toLocaleLowerCase();
        NotifyError(GeneralStore?.codeLabels[msg]?.label);
      } else {
        NotifyError(msgs);
      }
    }

    runInAction(() => {
      this.refundResponse = res.result;
    });
    return res;
  });
  sendOtpForCashPayout = ErrorWrapper(async (data: any) => {
    // const data = {
    //   mode: mobile ? "mobile" : email && mobile ? "both" : email ? "email" : personID ? "personID" : "mobile",
    //   personID,
    //   email,
    //   mobile, //.replaceAll('-', '')
    //   premiseID: premiseId,
    // };
    // console.log("data sendotp", data)

    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.CASH_PAYOUT_SENDOTP,
      type: "POST",
      data,
    });
    this.otp = res.result.otp;
    return res;
  });

  // Method has no references 
  // verifyRefundOTPDeprecated = ErrorWrapper(async (oneTimePasswordConfirm: string) => {
  //   console.log("verifyRefundOTP", oneTimePasswordConfirm);
  //   const data = {
  //     oneTimePasswordConfirm,
  //     otp: this.otp,
  //   };

  //   const res = await callRemoteMethod({
  //     endpoint: CONSTANTS.URL.verifyRefundOTPDeprecated,
  //     type: "POST",
  //     data,
  //   });

  //   // runInAction(() => {
  //   //   this.otpResult = res.result;
  //   // });
  //   return res;
  // });
  cashPayout = ErrorWrapper(async (payload: any) => {
    const {oneTimePasswordConfirm, transactionId} = payload;
    const accountList: Obj[] = this.selectedAccounts.map((account) => {
      return {
        accountId: account.accountId,
        amount: account.accountBalance.toString(),
      };
    });
    console.log("accountList", accountList);

    // Same fix as makeRefund: exact in fils, and cannot throw on a zero balance.
    const totalAmount = filsToAmountString(
      sumFils(this.selectedAccounts.map((account) => account.accountBalance))
    );
    const otpData = {
     oneTimePasswordConfirm,
      otp: this.otp,
      transactionId
      // estimatedBillId: "",
      // platform: "",
      // amount: 0,
      // accountId: "",
      // personId: "",
      // isMoveIn: true,
    };
    const data = {
      accountList,
      totalAmount,
      otpData,
    };
    console.log("personId", User?.profile?.personId);
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.CASH_PAYOUT(User?.profile?.personId),
      type: "POST",
      data,
    });
    runInAction(() => {
      this.cashPayoutResponse = res.result;
    });
    return res;
  });

  getRefundHistory = ErrorWrapper(async (personId: string) => {
    const res = await callRemoteMethod({
      endpoint: CONSTANTS.URL.REFUND_HISTORY(personId),
    });

    runInAction(() => {
      this.refundHistory = res.result;
    });
  });

  addSelectedAccounts = (account: Obj) => {
    this.selectedAccounts[0] = account;
  };

  removeSelectedAccounts = (accountId: string) => {
    this.selectedAccounts = this.selectedAccounts.filter(
      (account) => account.accountId !== accountId
    );
  };
  emptySelectedAccounts = () => {
    this.selectedAccounts = [];
  };
}

const refundAndTransferStore = new RefundAndTransfer();
export default refundAndTransferStore;
